<div class="confirm-dialog">
    <button type="button" class="close-button" aria-label="Dialog schließen" (click)="cancel()">
        ×
    </button>

    <h2>{{ data.title }}</h2>
    <p>{{ data.message }}</p>

    <footer class="dialog-actions">
        <button type="button" class="cancel-button" (click)="cancel()">
            {{ data.cancelText }}
        </button>

        <button type="button" class="delete-button" (click)="confirm()">
            {{ data.confirmText }}
        </button>
    </footer>
</div>